import React from 'react';

import { Stack, Typography } from '@mui/material';

import { LimitSection } from './LimitSection';
import { limitsQrc, limitsRmds } from '../../../../effector/limits';
import { ClientAccountInfo } from '../../../../types/clientFullInfo';

type ClientPositionsProps = {
  agreementId: string;
  info: ClientAccountInfo;
};

export const ClientPositions: React.FC<ClientPositionsProps> = ({ agreementId, info }) => (
  <Stack spacing={2}>
    <Typography variant="h6">Текущие позиции клиента</Typography>
    <LimitSection
      agreementId={agreementId}
      serviceName="RMDS"
      limitsApi={limitsRmds.api}
      limits$={limitsRmds.store$}
      info={info}
    />
    <LimitSection
      agreementId={agreementId}
      serviceName="QRC"
      limitsApi={limitsQrc.api}
      limits$={limitsQrc.store$}
      info={info}
    />
  </Stack>
);
